import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TitanAvatarComponent } from '../titan-avatar/titan-avatar.component';
import { TitanIconComponent } from '../titan-icon/titan-icon.component';
import { TitanMenuPopoverComponent } from '../titan-menu-popover/titan-menu-popover.component';
import { TitanMenuItemComponent } from '../titan-menu-item/titan-menu-item.component';
import { TitanMenuTriggerComponent } from '../titan-menu-trigger/titan-menu-trigger.component';
import { TitanMenuComponent } from '../titan-menu/titan-menu.component';
import { TitanDivider } from '../titan-divider/titan-divider';
import { SessionProviderService } from '../../services/sp-authentication/session-provider.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { RoleUtils } from '../../utils/role/role-utils';
import { AudienseEcosystemMenu } from '../audiense-ecosystem-menu/audiense-ecosystem-menu.component';

// CS's Office Hours programme, now a recurring Live Q&A on Zoom events (US #738).
// One registration page for every region and every Discover app; CS owns the
// destination, we only own the link.
const LIVE_QA_URL =
  'https://events.zoom.us/ev/AlQnIz8uogfjbX_olp7xMXWnh1k-ByQiinT8GA_64Z-HvqYdLa5B~AhaRMrLfltRMMzz5sozw-pKd43hq8Ty1WljipJ1uEReRiQt-EZMzRq98lA';

@Component({
  selector: 'app-titan-navbar',
  templateUrl: './titan-navbar.component.html',
  styleUrls: ['./titan-navbar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TitanAvatarComponent,
    TitanIconComponent,
    TitanMenuPopoverComponent,
    TitanMenuItemComponent,
    TitanMenuTriggerComponent,
    TitanMenuComponent,
    TitanDivider,
    AudienseEcosystemMenu
  ]
})
export class TitanNavBarComponent {
  env = environment;
  RoleUtils = RoleUtils;

  constructor(
    public sessionProvider: SessionProviderService,
    private cookie: CookieService,
    private router: Router
  ) {}

  handleSignOut(): void {
    this.sessionProvider.logout();
  }

  toggleDebugMode(): void {
    environment.config.enableDebugFeatures = !environment.config.enableDebugFeatures;
    if (environment.config.enableDebugFeatures) {
      this.cookie.set('debug', 'on', 0, '/', undefined, true, 'Strict');
    } else {
      this.cookie.delete('debug', '/');
    }
  }

  navigateToAdmin(): void {
    this.router.navigate(['/admin']);
  }

  navigateToAccount(): void {
    this.router.navigate(['/account']);
  }

  navigateToProjectList(): void {
    this.router.navigate(['/projects/list']);
  }

  navigateToUserGuide(): void {
    window.open('https://knowledge.audiense.com/en/soprism', '_blank');
  }

  navigateToMindsetGlossary(): void {
    window.open('https://help.audiense.com/soprism-mindset-glossary', '_blank');
  }

  navigateToMcpConnector(): void {
    window.open('https://knowledge.audiense.com/mcp/mcp-connections-audiense-ai-powered-audience-insights-your-way', '_blank');
  }

  navigateToMcpSupport(): void {
    window.open('https://knowledge.audiense.com/mcp', '_blank');
  }

  navigateToContactUs(): void {
    window.open('https://share.hsforms.com/1Q15CYppjRb-bFgd0CZZWwg4k1o4', '_blank');
  }

  navigateToAcademy() {
    window.open('https://academy.audiense.com/pages/homepage', '_blank');
  }

  navigateToProductFeedback() {
    window.open('https://form.typeform.com/to/kKNkDZpS', '_blank');
  }

  navigateToLiveQA(): void {
    window.open(LIVE_QA_URL, '_blank');
  }
}
